import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import SmProjectDetailDrawer, {
  ProjectDetailProps,
} from 'containers/SmWorkbench/ProjectDetail/Drawer';
import * as actions from 'modules/actions/lsProjectDetail';
import { projectMove, projectDelete } from 'modules/actions/lsProjectMove';
import { MENUS_REQUEST_ACTONS_MAPPING } from '../../utils';

class ProjectDetailDrawer extends React.Component<ProjectDetailProps> {
  getBodyProgress = () => {
    return require('../Show/Progress/index').default;
  }

  getBottomTabElement = (activeTabKey: string) => {
    let tabElement: any = null;
    try {
      tabElement = require(`../Show/Detail/Bottom/${_.upperFirst(
        activeTabKey,
      )}/index`).default;
    } catch (err) {
      tabElement = null;
    }
    return tabElement;
  }

  render() {
    return (
      <SmProjectDetailDrawer
        {...this.props}
        menuRequestMapping={MENUS_REQUEST_ACTONS_MAPPING}
        getBodyProgress={this.getBodyProgress}
        getBottomTabElement={this.getBottomTabElement}
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  const account = state.account;
  const projectDetail = state.lsProjectDetail;
  const menu = _.find(_.get(account, 'menus') || [], (menu: any) => {
    return menu.key === 'lsWorkbench';
  });
  return {
    menus: _.get(menu, 'children'),
    projectDetail,
  };
};

const mapDispatchToProps = () => {
  return {
    loadDetail: actions.loadDetail,
    clearDetail: actions.clearDetail,
    toggleDrawerSiderShow: actions.toggleDrawerSiderShow,
    projectMove,
    projectDelete,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetailDrawer);
